import { ChangeDetectionStrategy, Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StepsNavigationMapService } from '../../services/steps-navigation.service';
import { BreakpointsService } from 'src/app/services/breakpoints.service';
import { IndicatorsService } from '../../services/indicators.service';
import { PlannerDayStateService } from '../../../planner/services';
import { RouteDataService } from '../../services/route-data.service';
import { Point, Transfers } from 'src/app/pages/custom-route/interfaces/custom-route.interface';
import { RealTimeNavigationService } from '../../services/real-time-navigation.service';

@Component({
    selector: 'map-step-navigation',
    standalone: true,
    imports: [ 
        CommonModule, 
        TranslateModule 
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './step-navigation.component.html',
    styleUrl: './step-navigation.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class MapStepNavigationComponent {
    private _realTimeNavigationService: RealTimeNavigationService = inject(RealTimeNavigationService);
    private _routeDataService: RouteDataService = inject(RouteDataService);
    private _stepsNavigationService: StepsNavigationMapService = inject(StepsNavigationMapService);
    private _plannerDayStateService: PlannerDayStateService = inject(PlannerDayStateService);
    private _breakpointsService: BreakpointsService = inject(BreakpointsService);
    private _indicatorsService: IndicatorsService = inject(IndicatorsService)

    public transfers = computed<Transfers[]>(() => this.routeSegments()?.[this.currentTrameIndex()]?.transfers);
    
    public activeSegmentByHour = computed<boolean>(() => this._routeDataService.getActiveSegmentByHour());
    public isFakeGPSActive = computed<boolean>(() => this._realTimeNavigationService.isFakeGPSActive())
    public isGeolocationActive = computed<boolean>(() => this._routeDataService.isGeolocationActive());
    private isMobile = computed<boolean>(() => this._breakpointsService.isMobile());
    
    public dayToShowIndex = computed<number>(() => this._plannerDayStateService.dayToShowIndex());
    public totalDays = computed<number>(() => this._routeDataService.getRouteSegments()?.length - 1);
    public routeSegments = computed<Point[]>(() => this._routeDataService.getRouteSegments()?.[this.dayToShowIndex()]);
    public currentTrameIndex = computed<number>(() => this._routeDataService.getCurrentTrameIndex());
    public currentStepIndex = computed<number>(() => this._routeDataService.getCurrentStepIndex());

    private nextDay(): void {        
        const nexDay = this.dayToShowIndex() + 1;
        this._plannerDayStateService.setDayToShowIndex(nexDay);
    }

    public nextStep(): void {
        this._stepsNavigationService.nextStep();
    }

    public prevStep(): void {
        this._stepsNavigationService.prevStep();
    }

    public showNextButton(): boolean{
        const totalStepsCurrentTrame = this.routeSegments()?.[this.currentTrameIndex()]?.transfers?.length - 1;
        if (this.currentStepIndex() >= totalStepsCurrentTrame)
            return false;
        
        return true;
    }

    public showPrevButton(): boolean{
        if (this.currentStepIndex() === 0 && this.currentTrameIndex() === 0)
          return false;

        return true;
    }

    public isFinal(): boolean{
        if (this.currentTrameIndex() === this.routeSegments()?.length - 1 && 
            this.currentStepIndex() === this.routeSegments()?.[this.currentTrameIndex()]?.transfers?.length - 1)
                return true;

        return false;
    }

    public goNextTrame(): void {
        if (this.isFinal() && this.totalDays() !== this.dayToShowIndex()){
            this.nextDay();
            return;
        }
            
        if (this.showNextButton()){
            this.handleStepClick();
            return;
        }

        this.nextStep();
    }

    public handleStepClick(): void {
        if (this.isMobile()) 
            this._indicatorsService.openBottomSheetTransfersMobile(this.transfers());
        else 
            this._indicatorsService.openBottomSheetTransfersDesktop(this.transfers());
    }

    public touchStartNext(e: any): void {
        e.preventDefault(); 
        this.nextStep();
    }

    public touchStartPrev(e: any): void {
        e.preventDefault(); 
        this.prevStep();
    }

    public touchStartMiddle(e: any): void {
        e.preventDefault(); 
        this.goNextTrame();
    }

}